import './App.css';
import { useState } from 'react';

function App() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAsiaDropdownOpen, setIsAsiaDropdownOpen] = useState(false);

  const handleUSASellerClick = () => {
    // Replace with your desired URL
    window.location.href = 'https://vendor-us.vreels.com/';
  };

  const handleIndiaSellerClick = () => {
    // Replace with your desired URL
    window.location.href = 'https://vendor-in.vreels.com/';
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleAsiaDropdown = () => {
    setIsAsiaDropdownOpen(!isAsiaDropdownOpen);
  };

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className="logo-section">
            <img src="/Logo_white_bg.png" alt="Vreels Vendor" className="navbar-logo" />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <div className="content-container">
          <div className="welcome-section">
            <h1>Welcome to the Vreels Vendor Hub!</h1>
            <p>Your gateway to selling, shining, and succeeding.</p>
            <p>Pick your portal and let's grow your business together.</p>
          </div>

          <div className="seller-options">
            <div className="region-section">
              <div className="region-header" onClick={toggleDropdown}>
                <div className="region-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="#ff9800" strokeWidth="2"/>
                    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="#ff9800" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="region-info">
                  <h3>North American seller</h3>
                  <span>1 region</span>
                </div>
                <div className={`expand-icon ${isDropdownOpen ? 'expanded' : ''}`}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M4 6L8 10L12 6" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              
              <div className={`region-options ${isDropdownOpen ? 'open' : 'closed'}`}>
                <div className="seller-option" onClick={handleUSASellerClick}>
                  <div className="location-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="#666" strokeWidth="2"/>
                      <circle cx="12" cy="10" r="3" stroke="#666" strokeWidth="2"/>
                    </svg>
                  </div>
                  <span>United States Seller</span>
                </div>
              </div>
            </div>

            <div className="region-section">
              <div className="region-header" onClick={toggleAsiaDropdown}>
                <div className="region-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#ff9800" strokeWidth="2"/>
                    <path d="M2 17l10 5 10-5M2 12l10 5 10-5" stroke="#ff9800" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="region-info">
                  <h3>Asia Seller</h3>
                  <span>1 region</span>
                </div>
                <div className={`expand-icon ${isAsiaDropdownOpen ? 'expanded' : ''}`}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M4 6L8 10L12 6" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              
              <div className={`region-options ${isAsiaDropdownOpen ? 'open' : 'closed'}`}>
                <div className="seller-option" onClick={handleIndiaSellerClick}>
                  <div className="location-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="#666" strokeWidth="2"/>
                      <circle cx="12" cy="10" r="3" stroke="#666" strokeWidth="2"/>
                    </svg>
                  </div>
                  <span>India Seller</span>
                </div>
              </div>
            </div>
            
            <div className="coming-soon-section">
              <p className="coming-soon">We are adding more regions soon</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
